<template>
  <el-dialog
    v-bind="dialogOption"
    :visible.sync="show"
    :class="b()"
    :close-on-click-modal="false"
    append-to-body
    @open="onOpen"
    @update:visible="$emit('update:visible', $event)"
  >
    <NetworkRequest
      ref="networkRef"
      :request="loadFieldListUsedDetail"
    >
      <div
        v-loading="loading"
        class="dialog-contet"
      >
        <div class="custom-field-header">
          <div class="content">
            {{ customFieldsNumber }}
          </div>
          <div
            v-if="isShowTip"
            class="field-tip"
          >
            {{ $t('rightsMana.customFields.number') }}
          </div>
        </div>
        <div
          class="tree-list"
        >
          <div
            v-for="item in treeList"
            :key="item.groupName"
            class="tree-item"
          >
            <div class="tree-item-title">
              {{ item.groupName }}({{ item.Number }})
            </div>
            <div
              class="tree-item-content"
            >
              <div
                v-for="row in item.list"
                :key="row.id"
                class="custom-field-tr"
              >
                <p class="custom-field-tr__cell custom-field-tr_icon-Unused">
                  <span class="icon-Unused">
                    {{ $t('rightsMana.customFields.Unused') }}
                  </span>
                </p>
                <p
                  v-overflow-tooltip
                  class="
                    custom-field-tr__cell
                    custom-field-tr__title
                    custom-field-tr__overflow-hidden
                    text-ellipsis
                  "
                >
                  {{ row.fieldName }}
                </p>
                <p class="custom-field-tr__cell custom-field-tr__name  icon-list">
                  {{ row.controlName }}
                  <span
                    v-if="hasPermission"
                    class="icon-container"
                    @click="handleClickForAction(item, row)"
                  >
                    {{ $t('button.delete') }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </NetworkRequest>
  </el-dialog>
</template>

<script>

import {
  loadFieldListUsedDetail,
  deleteField,
  deleteProjectCustomField,
  checkProjectCustomFieldDelete
} from 'common-module/src/api/Subscription';
import NetworkRequest from 'common-module/src/components/NetworkRequest/index.vue';


import theme from '@zk/theme/lib/variables.scss';
import { mapGetters } from 'vuex';
import * as permission from 'common-module/src/config/permission';

export default {
  name: 'CustomFieldOverTipsDialog',
  components: { NetworkRequest },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bemNS: theme.bemNS,
      treeList: [],
      customFieldsNumber: '20/20',
      loading: false,
      isShowTip: true
    };
  },
  computed: {
    ...mapGetters('user', ['checkAccessPermission']),
    hasPermission() {
      return this.checkAccessPermission(permission.systemFieldMgr);
    },
    dialogOption() {
      return {
        width: '950px',
        top: '50px',
        title: this.$t('rightsMana.FieldRestrictions')
      };
    },
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.updateDetail();
      }
    }
  },
  created() {
  },
  methods: {
    onOpen() {},
    handleClickForAction(row, item) {
      if (row.type === 'overview') {
        this.handleFieldDelete(item);
      } else {
        this.deleteField(item);
      }
    },
    handleFieldDelete(item) {
      this.$confirm(this.$t('project.issueType.layout.deleteDialog.msg', [item.fieldName]), this.$t('setting.delete_field_dialog_title'), {
        confirmButtonText: this.$t('button.delete'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonClass: 'el-button--danger'
      }).then(
        async () => {
          await checkProjectCustomFieldDelete(item.id);
          await deleteProjectCustomField(item.id);
          this.$message.success(this.$t('project.issueType.layout.deleteMsg', [item.fieldName]));
          this.$emit('updateData');
          this.updateDetail();
        }
      );
    },
    async deleteField(item) {
      this.$confirm(this.$t('project.issueType.layout.deleteDialog.msg', [item.fieldName]), this.$t('setting.delete_field_dialog_title'), {
        confirmButtonText: this.$t('button.delete'),
        cancelButtonText: this.$t('button.cancel'),
        confirmButtonClass: 'el-button--danger'
      }).then(
        async () => {
          await deleteField(item.id);
          this.$message.success(this.$t('project.issueType.layout.deleteMsg', [item.fieldName]));
          this.$emit('updateData');
          this.updateDetail();
        }
      );
    },
    updateDetail() {
      this.$nextTick(() => {
        this.$refs.networkRef ? this.$refs.networkRef.load() : this.loadFieldListUsedDetail();
      });
    },
    async loadFieldListUsedDetail(config) {
      this.loading = true;
      const result = await loadFieldListUsedDetail({}, config);
      this.customFieldsNumber = `${result.productRemainingRight.usedNum}/${result.productRemainingRight.totalNum}`;
      this.isShowTip = result.productRemainingRight.usedNum >= result.productRemainingRight.totalNum;
      const orgFieldList = {
        groupName: this.$t('rightsMana.customOrgField'),
        type: 'org',
        Number: result.orgFieldList.length,
        list: result.orgFieldList
      };
      const projectOverviewField = {
        groupName: this.$t('rightsMana.projectOverviewField'),
        type: 'overview',
        Number: result.projectOverviewFieldList.length,
        list: result.projectOverviewFieldList
      };
      const projectField = {
        groupName: this.$t('rightsMana.projectField'),
        type: 'project',
        Number: result.projectFieldList.length,
        list: result.projectFieldList
      };
      this.treeList = [orgFieldList, projectOverviewField, projectField];
      this.loading = false;
      // console.log(11111, result);
    }
  }
};
</script>

<style lang="scss" scoped>
@include b(custom-field-over-tips-dialog) {
  .custom-field-header {
    margin-top: 6px;
    margin-bottom: var(--m-default);
    .lable {
      font-weight: var(--weight-font-Semiblod);
      font-size: var(--size-font-7);
      color: var(--font-color-1);
      margin-bottom: 4px;
    }
    .content {
      font-weight: var(--weight-font-Semiblod);
      font-size: var(--size-font-5);
      color: var(--primary-color);
    }
    .field-tip {
      font-size: var(--size-font-7);
      color: var(--font-color-2);
    }
  }
  .tree-list {
    .tree-item {
      margin-bottom: var(--m-default);
      .tree-item-title {
        font-weight: var(--weight-font-Semiblod);
        font-size: var(--size-font-7);
        color: var(--font-color-1);
        display: flex;
        align-items: center;
        padding: 8px 0;
      }
      .tree-item-content {
        overflow: hidden;
        border: 1px solid var(--color-border-2);
        border-radius: var(--radius-mini);
        padding: 4px 0px;
        min-height: 40px;
        .custom-field-tr {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 18px;
          font-size: var(--size-font-7);
          color: var(--font-color-2);
          >p {
            margin: 0;
            margin-right: 24px;
            .icon-Unused {
              background-color: var(--gray-2);
              border-radius: 2px;
              width: 46px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              display: inline-block;
              vertical-align: middle;
              font-size: var(--size-font-9);
            }
          }
          &__cell {
            max-width: 300px;
            flex: 1;
            margin-right: 24px;
          }
          &__title {
            color: var(--font-color-1);
            flex: 3;
          }
          &__name {
            flex: 4;
          }
          &__overflow-hidden {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .icon-list {
            // flex: 0 0 130px;
            // text-align: right;
            line-height: 26px;
            margin-right: 0;
            .icon-container {
              // display: none;
              visibility: hidden;
              cursor: pointer;
              font-size: var(--size-font-9);
              color:var(--state-danger-icon);
              background-color: #fff;
              border: 1px solid var(--color-border-2);
              // padding: 3px 15px;
              width: 72px;
              height: 26px;
              text-align: center;
              line-height: 26px;
              border-radius: var(--radius-mini);
              // vertical-align: middle;
              float: right;
              font-weight: var(--weight-font-Semiblod);
            }
          }
          &:hover {
            background-color: var(--gray-transparent-hover);
            .icon-list {
              .icon-container {
                // display: inline-block;
                visibility: visible;
              }
            }

          }
        }

      }

    }
  }
  ::v-deep .el-dialog__body.normalSizeMode {
    padding-top: 0;
  }
}
</style>

